var app = angular.module("leonardo");

var TaskNoteDialog = function ($scope, $state, $window, ngDialog, NoteService, FolderFileService, AccountUserService,
                               AttachmentService) {
  $scope.task = $scope.ngDialogData.task;
  $scope.only_view = $scope.ngDialogData.only_view;
  $scope.accountUserService = AccountUserService;
  $scope.attachmentService = AttachmentService;

  angular.forEach($scope.task.notes, function(note) {
    angular.forEach(note.attachments, function(attachment){
      fetchAttachment(attachment);
    });
  });

  $scope.init = function () {
    $scope.notes = $scope.task.notes;
  };

  $scope.removeNote = function (note) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/delete.html',
      controller: 'DeleteDialog',
      data: {
        object: note,
        type: 'note'
      }
    }).then(function(){
      angular.forEach($scope.task.notes, function(value,key){
        if (value.id == note.id) {
          $scope.task.notes.splice(key, 1);
        }
      });
      $scope.init();
    });
  };

  $scope.edditNote = function (note) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/task/add-note.html',
      controller: 'TaskAddNoteDialog',
      data: {action: 'edit', note: note, task: $scope.task}
    }).then(function (data) {
      angular.forEach(data.attachments, function(attachment){
        fetchAttachment(attachment);
      });
      angular.forEach($scope.task.notes, function(value,key) {
        if (value.id == note.id) {
          $scope.task.notes[key] = data;
        }
      });
      $scope.init();
    });
  };

  $scope.addNewNote = function () {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/task/add-note.html',
      controller: 'TaskAddNoteDialog',
      data: {task: $scope.task}
    }).then(function (note) {
      angular.forEach(note.attachments, function(attachment){
        fetchAttachment(attachment);
      });
      $scope.task.notes.push(note);
      $scope.init();
    });
  };

  $scope.openAttachmentDialog = function (attachments, index) {
    if (attachments[index].document_file) {
      $scope.getnotesFileObject(attachments, index);
    }
    else if (attachments[index].link) {
      $window.open(attachments[index].link);
    }
    else {
      $scope.getnotesFileObject(attachments, index);
    }
  };

  $scope.getnotesFileObject = function (attachments, index) {
    if (attachments[index].document_file) {
      // Use authenticated method for document files
      FolderFileService.getFileObjectAuthenticated(attachments[index].document_file, function (fileObject) {
        var array_url = (fileObject && fileObject.type) ? fileObject.type.split('/') : [];
        if (_.contains(array_url, 'image')) {
          ngDialog.open({
            template: 'views/templates/dialog/attachment/list.html',
            controller: 'AttachmentListDialog',
            className: 'ngdialog-theme-default ngdialog-attachments-view',
            data: {
              attachments: attachments,
              index: index
            }
          });
        }
        else {
          // Use signed_view_url for secure inline viewing
          $window.open(attachments[index].document_file.signed_view_url || attachments[index].document_file.secure_share_url);
        }
      });
    }
    else {
      // For external links or non-document files, use the old method
      FolderFileService.getFileObject(attachments[index].file, function (fileObject) {
        var array_url = (fileObject && fileObject.type) ? fileObject.type.split('/') : [];
        if (_.contains(array_url, 'image')) {
          ngDialog.open({
            template: 'views/templates/dialog/attachment/list.html',
            controller: 'AttachmentListDialog',
            className: 'ngdialog-theme-default ngdialog-attachments-view',
            data: {
              attachments: attachments,
              index: index
            }
          });
        }
        else {
          // Use signed_view_url for secure inline viewing
          $window.open(attachments[index].signed_view_url || attachments[index].secure_share_url || attachments[index].file);
        }
      });
    }
  };

  function fetchAttachment(attachment) {
    if (attachment.document_file) {
      attachment.file = attachment.document_file.signed_view_url;
    }
    else if (attachment.link) {
      attachment.file = attachment.link;
    }
  }

  $scope.init();
};

app.controller('TaskNoteDialog', ['$scope', '$state', '$window', 'ngDialog', 'NoteService', 'FolderFileService',
  'AccountUserService', 'AttachmentService', TaskNoteDialog]);
